module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAA5UlEQVQokZXSMSvFcRTG8c/lxmIRuVIWr8CgOyqRN2BXRiVv4A4y2w3KYlJ3syO7simD0Wggizoc/fjTdfu7+NYZfqeeznme8yOyt3ZFnooc7et/r57Hich7ke2BgkhNzOIQL5jwBxoibzGHDuYxXskaeMUTrrGHB5VoFUe4wSZaGENZfgjTWMIytnH8uWdL5JnI/QFe1kSmyMXGRxpfXFQTVkpENe62sN4vKizgqgqmjvNmTfPyl/yei9H/0MZM3Xo/MYxH7Ay8fFWTIjdE3onsll6ZNIUDjFTJ9VMslEN3338O3gDcsJTlmANmAwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/back.png
// module id = +XBy
// module chunks = 1